import { ChangeDetectorRef, Component, OnInit, OnDestroy, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { ItemService } from 'src/app/services/item.service';
import { ItemSimilar } from 'src/app/persistences/item-similar';

import { Subscription } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ClienteSingletonService } from 'src/app/singletons/cliente-singleton.service';
import { NumberUtils } from 'src/app/utils/utils/number-utils';
import { JwtService } from 'src/app/jwt.service';
import { CurrencyPipe } from '@angular/common';
import { SnackbarManager } from './../../managers/snackbar-manager';
import { MarcaService } from 'src/app/services/marca.service';
import { Marca } from 'src/app/persistences/marca';

@Component({
  standalone: false,
	selector: 'app-lista-similares',
	templateUrl: './lista-similares.component.html',
	styleUrls: ['./lista-similares.component.css']
})
export class ListaSimilaresComponent implements OnInit, OnDestroy {
	public imageObject: Array<object> = [];
	public imagensCarregadas = false;
	public similares: ItemSimilar[] = [];
	public listaSimilares = false;
	public colunas: number;
	public promocao: string;

	get validImages(): Array<any> {
		return this.imageObject.filter(img => img !== null);
	}

	/** Mesma lista/visual para os dois tipos; muda apenas o endpoint, o título e as mensagens. */
	@Input()
	public tipo: 'similares' | 'relacionados' = 'similares';

	get titulo(): string {
		return this.tipo === 'relacionados' ? 'Relacionados' : 'Similares';
	}

	@Input()
	public cdItemAtual: string;
	public cdItemCar: string;

	@Output()
	selecionado = new EventEmitter<number>();

	/** Consulta em andamento e identificador da última requisição: respostas de requisições antigas (A → B → C) são descartadas. */
	private assinatura?: Subscription;
	private requisicao = 0;

	constructor(
		private itemService: ItemService,
		private jwtService: JwtService,
		private currencyPipe: CurrencyPipe,
		private snackBarManager: SnackbarManager,
		private marcaService: MarcaService,
		private cdr: ChangeDetectorRef,
		private elementRef: ElementRef<HTMLElement>
	) {

	}

	ngOnDestroy(): void {
		this.limpar();
	}

	/** Cancela requisições pendentes e esvazia a lista (a seção some enquanto não houver itens). */
	limpar(): void {
		this.requisicao++;
		this.assinatura?.unsubscribe();
		this.similares = [];
		this.imageObject = [];
	}

	ngOnInit(): void {
		this.colunas = (window.innerWidth <= 700) ? 1 : 4;
	}

	onResize(event) {
		const width = event.target.innerWidth;
		if (width >= 1080) {
			this.colunas = 4;
		}
		if (width < 1080 && width > 800) {
			this.colunas = 3;
		}
		if (width < 800 && width > 700) {
			this.colunas = 2;
		}
		if (width < 700) {
			this.colunas = 1;
		}
	}


	carregaSimilares(id_item: number) {
		this.imagensCarregadas = false;
		this.limpar();
		const requisicao = this.requisicao;
		const similares: ItemSimilar[] = [];
		this.similares = similares;

		const consulta = this.tipo === 'relacionados'
			? this.itemService.getRelacionados(id_item)
			: this.itemService.getSimilares(id_item);

		this.assinatura = consulta.pipe(
			mergeMap((res: any[]) => {
				if (res != undefined) {
					res["itens"].forEach((item) => {
					const a = new ItemSimilar(
						undefined,
						item["idItem"],
						item["nmItem"],
						item["estoqueDisponivel"] ? item["cdItem"] : 'INDISPONÍVEL - '+item["cdItem"],
						item["qtAtual"],
						item["qtDisponivel"],
						item["estoqueDisponivel"],
						item["preco"],
						item["flPromocao"],
						item["pcMaxDescontoAut"],
						item["ipi"],
						item["st"],
						item["ipiSt"],
						item["cdMarca"],
						item["precoLiquido"],
						item["precoLiquidoComIpiIcmsSubstituicao"]);
					similares.push(a);
					});
				}

				similares.sort((a, b) => {
					const aIndisponivel = a.cdItem.startsWith("INDISPONÍVEL");
					const bIndisponivel = b.cdItem.startsWith("INDISPONÍVEL");
					return aIndisponivel === bIndisponivel ? 0 : aIndisponivel ? 1 : -1;
				});

				this.imageObject = Array.from({ length: similares.length }).map((_, i) => ({
					thumbImage: "assets/images/sem_imagem.png",
					title: "",
					index: i
				}));
				similares.forEach((s, i) => s.indice = i);

				return similares;
			})
		)
		.subscribe(
			(similar: ItemSimilar) => {
			let marcaSimilar = new Marca();
			this.marcaService.getMarcaById(similar.cdMarca).subscribe((marca)=> {
				if (requisicao !== this.requisicao) { return; }
				marcaSimilar = marca;

				this.itemService.getImagem(similar.idItem, true).subscribe(
					(imagem: string) => {
						if (requisicao !== this.requisicao) { return; }
						similar.imagem = imagem == "" ? "assets/images/sem_imagem.png" : "data:image/jpeg;base64," + imagem;
						this.promocao = similar.flPromocao ? "- PROMOÇÃO" : " ";

						const valorString = this.currencyPipe.transform(similar.precoLiquidoComIpiIcmsSubstituicao, "R$");
						const title = `${similar.cdItem} - ${marcaSimilar.nmMarca} - ${valorString} ${this.promocao}`;

						const pos = similar.indice!;
						this.imageObject[pos] = {
							thumbImage: similar.imagem,
							title: title,
							index: pos
						};
						this.cdr.detectChanges();
					},
					(error) => {
						if (requisicao !== this.requisicao) { return; }
						this.jwtService.validarAcessToken(error);
						this.snackBarManager.openSnackBarErro(error, `Não foi possível carregar os itens ${this.tipo}.`, "Ok", 3000);
					}
				);
			});
			},
			(error) => {
			if (requisicao !== this.requisicao) { return; }
			this.jwtService.validarAcessToken(error);
			this.snackBarManager.openSnackBarErro(error, `Não foi possível carregar os itens ${this.tipo}.`, "Ok", 3000);
			}
		);

		this.imagensCarregadas = true;
	}


	onClickImagem(eventOrIndex: any) {
		const ind = typeof eventOrIndex === 'number' ? eventOrIndex : (eventOrIndex && eventOrIndex.index != null ? eventOrIndex.index : null);
		if (ind == null) return;

		const item = this.similares.find(i => i.indice === ind);
		if (item) {
			this.cdItemAtual = this.removerPrefixoIndisponivel(item.cdItem);
			this.selecionado.emit(item.idItem);
		}

		this.setDestaque();
	}

	/** Remove o prefixo "INDISPONÍVEL - " para comparar sempre pelo código real do item. */
	private removerPrefixoIndisponivel(cdItem: string): string {
		return cdItem.replace(/^INDISPONÍVEL - /, '');
	}

	/** Destaca a legenda do item atual somente nesta instância (Similares e Relacionados são independentes). */
	setDestaque() {
		const destaque = this.elementRef.nativeElement.querySelectorAll<HTMLElement>('.caption');
		const cdAtual = this.cdItemAtual == null ? '' : this.removerPrefixoIndisponivel(this.cdItemAtual);
		destaque.forEach((legenda) => {
			const cdLegenda = this.removerPrefixoIndisponivel(legenda.innerHTML.trim()).split(' - ')[0];
			if (cdLegenda == cdAtual) {
				legenda.style.background = 'black';
			} else {
				legenda.style.background = ' linear-gradient(to right, rgba(0, 0, 0, .6), rgba(0, 0, 0, .6), rgba(0, 0, 0, .6), rgba(0, 0, 0, .6), rgba(0, 0, 0, .6))';
			}
		});
	}
}
